import { EventEmitter, Injectable, Output } from "@angular/core";
import { MessageService } from "primeng/api";
import { environment } from "src/environment/environment";
import { HttpClient } from "@angular/common/http";
import { LocalStorageService } from "angular-web-storage";
import { User } from "../../users/_types/user";
import { IMqttMessage, MqttService } from "ngx-mqtt";
import { LoginService } from "../../login/login.service";

@Injectable({
    providedIn: 'root',
})
export class PhoneService {

    @Output() onShowSidebar = new EventEmitter<boolean>();
    @Output() onNotificationReaded = new EventEmitter<void>();
    @Output() onIncomingCall = new EventEmitter<any>();

    public isConnected:boolean = false;
    public connectionStatus:string = "";
    private intervalPhoneStatus:any;
    public calls:any[] = [];
    private user?:User;

    constructor(
        private _http: HttpClient,
        private messageService: MessageService,
        private storage:LocalStorageService,
        private mqttService:MqttService,
        private loginService: LoginService
    ) { 
        console.log("phoneService");

        this.loginService.onLogin.subscribe((isLoged:boolean) => {
            console.log("onLogin", isLoged);
            if(isLoged){
                this.setupMqttSubscriptions();
                this.setupPhone();
            }else{
                //desubscribirse
                console.log("desubscribirse");
            }
        });

    }

    setupMqttSubscriptions() {
        //cargamos usuario
        this.user = this.storage.get("user");

        //subscribimos a topic de usuario
        if(this.user!=null){
            console.log("Subscribing to MQTT topic: users/" + this.user?.id + "/phone");
            this.mqttService.observe('users/' + this.user?.id + '/phone').subscribe((data:IMqttMessage) => {
                //let message:ChatRoomMessage = JSON.parse(data.payload.toString());
                let message:any = JSON.parse(data.payload.toString());
                console.log("PhoneService MQTT message:", message);
                if(message.type=="CallInfoUpdate"){
                    this.handleCallInfoUpdate(message);
                }
            });
        }
    }

    setupPhone(){
        //TODO: consultar de asterisk
        this.user = this.storage.get("user");
        if(this.user?.sipExtension!=null && this.user?.sipExtension!="") this.onConnectionStatus({ isConnected: true, connectionStatus: "Connected" });
    }

    ngOnDestroy() {
        //clearInterval(this.intervalPhoneStatus);
    }

    onConnectedToWebSocket(){
        //obtener lista de llamadas en curso
    }

    onConnectionStatus(status:any) {
        console.log("onConnectionStatus", status);
        this.isConnected = status.isConnected;
        this.connectionStatus = status.connectionStatus;
    }

    openPhone() {
        this.onShowSidebar.emit(true);
    }

    closePhone() {
        this.onShowSidebar.emit(false);
    }

    /*onResponse(response:any) {
        let responseXML:string = response.content;

        if (responseXML.length > 0) {
            let parser = new DOMParser();
            let xmlDoc:Document = parser.parseFromString(responseXML, "text/xml");
        
            var statusElement = xmlDoc.getElementsByTagName("status")[0];
            if (statusElement != null) {
                let statusType:any = statusElement.getAttributeNode("type");
                let nodeValue:string = statusType.nodeValue;
                console.log('Status Response type: ' + statusType.nodeValue);
                if(nodeValue=="call"){
                    this.handleCallStatusResponse(xmlDoc);
                }else if(nodeValue=="callhistory"){
                    this.handleCallHistoryStatusResponse(xmlDoc);
                }else if(nodeValue=="screenshare"){
                    this.handleScreenShareStatusResponse(xmlDoc);
                }else if(nodeValue=="authentication"){
                    this.handleAuthenticationStatusResponse(xmlDoc);
                }else{
                    console.log('Unhandled response type: ' + responseXML);
                }
            }
        }
    }*/

    handleCallInfoUpdate(message:any) {

        //extraemos llamdas y participantes
        /*this.calls = [];
        for(let i=0; i<message.calls.length; i++){
            let statusCall = message.calls[i];
            let call:any = {
                id: statusCall.uniqueid,
                participants: []
            };
            let participants = statusCall.getElementsByTagName("participant");
            console.log(participants);
            for(let j=0; j<participants.length; j++){
                let participant = participants[j];
                let participantInfo:any = {
                    number: participant.getElementsByTagName("number")[0].textContent,
                    displayName: participant.getElementsByTagName("displayName")[0].textContent,
                    state: participant.getElementsByTagName("state")[0].textContent,
                    timeInitiated: participant.getElementsByTagName("timeInitiated")[0].textContent
                };
                call.participants.push(participantInfo);
            }
            this.calls.push(call);
        }*/

        //emitimos el evento de llamada entrante
        this.onIncomingCall.emit(message.calls);

    }

    async call(phoneNumber: string, callerId: string|null = null, openPhone:boolean = true, caseId:string|null = null, caseServiceId:string|null = null) {
        console.log("call", phoneNumber, openPhone, caseId, caseServiceId);

        if(!this.isConnected) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No tienes tu extensión conectada. Revisa tu softphone.' });
            return;
        }
        
        //obtenemos usuario de localstorage
        let user:User = this.storage.get("user");
        console.log(user);
        if(user==null || user.sipExtension==null || user.sipExtension==''){
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tu usuario no tiene una extensión configurada.' });
            return;
        }

        try{
            //lanzamos llamada al servicio para que pueda añadir las cabeceras oportunas
            //codificamos los parámetros en la url
            let url = environment.api_gw + 'communications/phone/call?';
            url += '&fromNumber=' + encodeURIComponent(user.sipExtension);
            if(callerId!=null) url += '&callerId=' + encodeURIComponent(callerId);
            url += '&toNumber=' + encodeURIComponent(phoneNumber);
            if(caseId) url += '&caseId=' + encodeURIComponent(caseId);
            if(caseServiceId) url += '&caseServiceId=' + encodeURIComponent(caseServiceId);
            this._http.get(url).subscribe((data: any) => {
                if(data.response == "Error"){
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.message });
                }
            });
        }catch(e:any){
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al realizar la llamada: ' + e.message });
        }
    }

    async answer(call: any) {
        //this.briaService.apiAnswerCall(call.id, false);
    }

    async hangup(call: any) {
        //this.briaService.apiEndCall(call.id);
    }

}
